import React from 'react';
import "./ForecastPrintable.scss";

const ForecastPrintable = (props) => {
    return (
        <React.Fragment>
        {props.loading ? "" : (
        <div className="forecastPrint" style={{display:"none"}}>
        <hr />
        <div style={{width: "90%", display: "table"}}>
            <div style={{display: "table-row"}}>
                <div style={{width: "180px", display: "table-cell", verticalAlign:"top", textAlign:"center"}}>
                    <h3>{props.data.forecastDay[0].dayName}</h3>
                    {props.data.forecastDay[0].dayIcon !== "" ? <img style={{height:"90px"}} alt='' src={"https://cdn.gov.je/govje/JerseyMet/images/icons/"+props.data.forecastDay[0].dayIcon} /> : ""}                                             
                </div>
                <div style={{display: "table-cell", verticalAlign:"top", paddingLeft:"10px"}}>
                    <div style={{fontSize:"14px"}}>{props.data.validTime}</div>

                    <div style={{fontSize:"18px"}}><strong>Max</strong> <span className="temp">{props.data.forecastDay[0].maxTemp}</span>&nbsp;&nbsp;&nbsp;<strong>Min</strong> <span className="temp">{props.data.forecastDay[0].minTemp}</span>&nbsp;&nbsp;&nbsp; UV Index: <strong>{props.data.forecastDay[0].uvIndex}</strong></div>
                    

                    <div style={{margin:"10px 0"}}>{props.data.forecastDay[0].summary} {props.data.forecastDay[0].frost}</div>
                    <div style={{margin:"10px 0"}}><strong>Wind:</strong> {props.data.forecastDay[0].windSpeed} {props.data.forecastDay[0].windDescription}</div>
                </div>
            </div>
        </div>
        <hr />
        <div style={{width: "90%", display: "table", marginBottom:"0", paddingBottom:"0"}}>
            <div style={{display: "table-row"}}>
                <div style={{width: "180px", display: "table-cell", verticalAlign:"top", textAlign:"center"}}>
                    <h3>{props.data.forecastDay[1].dayName}</h3>
                    {props.data.forecastDay[1].dayIcon !== "" ? <img style={{height:"90px"}} alt='' src={"https://cdn.gov.je/govje/JerseyMet/images/icons/"+props.data.forecastDay[1].dayIcon} /> : ""}                                             
                </div>
                <div style={{display: "table-cell", verticalAlign:"top", paddingLeft:"10px", paddingBottom:"0"}}>
                    <div><strong>Max</strong> <span className="temp">{props.data.forecastDay[1].maxTemp}</span>&nbsp;&nbsp;&nbsp;<strong>Min</strong> <span className="temp">{props.data.forecastDay[1].minTemp}</span>&nbsp;&nbsp;&nbsp;UV Index: <strong>{props.data.forecastDay[1].uvIndex}</strong></div>
                    <p>{props.data.forecastDay[1].summary} {props.data.forecastDay[1].frost}</p>
                    <p><strong>Wind:</strong> {props.data.forecastDay[1].windDescription}</p>
                </div>
            </div>
        </div>
        <hr />
        <div style={{width: "100%", display: "table"}}>
            <div style={{display: "table-row"}}>
                <div style={{width: "49%", display: "table-cell", verticalAlign:"top", fontSize:"16px"}}>
                    <div style={{width: "90%", display: "table"}}>
                        <div style={{display: "table-row"}}>
                            <div style={{width: "180px", display: "table-cell", verticalAlign:"top", textAlign:"center"}}>
                                <h3>{props.data.forecastDay[2].dayName}</h3>
                                {props.data.forecastDay[2].dayIcon !== "" ? <img style={{height:"70px"}} alt='' src={"https://cdn.gov.je/govje/JerseyMet/images/icons/"+props.data.forecastDay[2].dayIcon} /> : ""}     
                            </div>
                            <div style={{display: "table-cell", verticalAlign:"top", paddingLeft:"10px"}}>
                                <div><strong>Max</strong> <span className="temp">{props.data.forecastDay[2].maxTemp}</span></div>
                                UV Index: <strong>{props.data.forecastDay[2].uvIndex}</strong>
                                <p>{props.data.forecastDay[2].summary}</p>
                                <p style={{fontSize:"15px"}}><strong>Wind:</strong> {props.data.forecastDay[2].windToolTip}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{borderLeft:"1px solid #ccc", height:"100%", display:"table-cell", verticalAlign:"top"}}></div>

                <div style={{display: "table-cell", verticalAlign:"top", fontSize:"16px"}}>
                    <div style={{width: "90%", display: "table"}}>
                        <div style={{display: "table-row"}}>
                            <div style={{width: "180px", display: "table-cell", verticalAlign:"top", textAlign:"center"}}>
                                <h3>{props.data.forecastDay[3].dayName}</h3>
                                {props.data.forecastDay[3].dayIcon !== "" ? <img style={{height:"70px"}} alt='' src={"https://cdn.gov.je/govje/JerseyMet/images/icons/"+props.data.forecastDay[3].dayIcon} /> : ""} 
                            </div>
                            <div style={{display: "table-cell", verticalAlign:"top", paddingLeft:"10px"}}>
                                <div><strong>Max</strong> <span className="temp">{props.data.forecastDay[3].maxTemp}</span></div>
                                UV Index: <strong>{props.data.forecastDay[3].uvIndex}</strong>
                                <p>{props.data.forecastDay[3].summary}</p>
                                <p style={{fontSize:"15px"}}><strong>Wind:</strong> {props.data.forecastDay[3].windToolTip}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <hr />

        <div style={{width: "100%", display: "table"}}>
            <div style={{display: "table-row"}}>
                <div style={{width: "49%", display: "table-cell", verticalAlign:"top", fontSize:"16px"}}>
                    <div style={{width: "90%", display: "table"}}>
                        <div style={{display: "table-row"}}>
                            <div style={{width: "180px", display: "table-cell", verticalAlign:"top", textAlign:"center"}}>
                                <h3>{props.data.forecastDay[4].dayName}</h3>
                                {props.data.forecastDay[4].dayIcon !== "" ? <img style={{height:"70px"}} alt='' src={"https://cdn.gov.je/govje/JerseyMet/images/icons/"+props.data.forecastDay[4].dayIcon} /> : ""} 
                            </div>
                            <div style={{display: "table-cell", verticalAlign:"top", paddingLeft:"10px"}}>
                                <div><strong>Max</strong> <span className="temp">{props.data.forecastDay[4].maxTemp}</span></div>
                                UV Index: <strong>{props.data.forecastDay[4].uvIndex}</strong>
                                <p>{props.data.forecastDay[4].summary}</p>
                                <p style={{fontSize:"15px"}}><strong>Wind:</strong> {props.data.forecastDay[4].windToolTip}</p>
                            </div>
                        </div>
                    </div>
                </div>


                <div style={{borderLeft:"1px solid #ccc", height:"100%", display: "table-cell", verticalAlign:"top"}}></div>

                <div style={{display: "table-cell", verticalAlign:"top", fontSize:"16px"}}>
                    <div style={{width: "90%", display: "table"}}>
                        <div style={{display: "table-row"}}>
                            <div style={{width: "180px", display: "table-cell", verticalAlign:"top", textAlign:"center"}}>
                                <h3>{props.data.forecastDay[5].dayName}</h3>
                                {props.data.forecastDay[5].dayIcon !== "" ? <img style={{height:"70px"}} alt='' src={"https://cdn.gov.je/govje/JerseyMet/images/icons/"+props.data.forecastDay[5].dayIcon} /> : ""} 
                            </div>
                            <div style={{display: "table-cell", verticalAlign:"top", paddingLeft:"10px"}}>
                                <div><strong>Max</strong> <span className="temp">{props.data.forecastDay[5].maxTemp}</span></div>
                                UV Index: <strong>{props.data.forecastDay[5].uvIndex}</strong>
                                <p>{props.data.forecastDay[5].summary}</p>
                                <p style={{fontSize:"15px"}}><strong>Wind:</strong> {props.data.forecastDay[5].windToolTip}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style={{fontSize:"14px", padding: "15px 30px 0 30px"}}>
            (disclaimer) For latest information check out - www.gov.je/weather - or speak direct to the forecaster on 0905807 7777 (charge at £1.50 per min)
        </div>
    </div>      
            )}
        
        </React.Fragment> 
    );    
}
export default ForecastPrintable;